import {
    SidebarInset,
} from "@/components/ui/sidebar"
import { AppBar } from "@/layout"
import { useState } from "react";
import DashboardCardsCommissionPartners from "./components/commission_partners/DashboardCards";
import UpcomingOrders from "./components/UpcomingOrders";
import OrderDetails from "../orders/OrderDetails";
import NewOrders from "./components/NewOrders";
import PartnerReports from "./components/commission_partners/Reports";
import { Orders } from "@/interface/entityInterface";
import { handleRowClick } from "@/utils/functions";

export const DashboardCommissionPartner = () => {

    const [open, setOpen] = useState(false)
    const [order, setOrder] = useState(null)
    const [manifestLength, setManifestLength] = useState(0)

    return (
        <SidebarInset>
            <AppBar />
            <div className="@container/main flex flex-1 flex-col gap-2 pt-5">
                <DashboardCardsCommissionPartners />
            </div>
            <div className={`@container/main lg:grid ${manifestLength > 0 ? 'grid-cols-1' : 'grid-cols-6'} place-items-stretch pt-5 px-4 lg:px-6 gap-4`}>
                <div className="w-full h-full mt-5 lg:mt-0 place-self-stretch">
                    <NewOrders setManifestLength={setManifestLength} rowClick={(row: Orders) => handleRowClick(row, setOrder, setOpen)} />
                </div>
                <div className={`w-full h-full mt-5 lg:mt-0 ${manifestLength === 0 && 'col-span-5'}`}>
                    <UpcomingOrders rowClick={(row: Orders) => handleRowClick(row, setOrder, setOpen)} />
                </div>
            </div>
            <div className="@container/main pt-5 px-4 lg:px-6">
                <PartnerReports />
            </div>
            <OrderDetails selectedOrder={order} isSheetOpen={open} setIsSheetOpen={setOpen} />
        </SidebarInset>
    )
}

export default DashboardCommissionPartner;